import _ from "lodash";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Swal from "sweetalert2";

import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";
import { clearLocalStorageAuth } from "@utils/localStorage";
import { VALIDATE_RULES } from "@validate/index";

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

export const FormEditProfile = ({ userProfile, setIsModalVisible }) => {
  const navigate = useNavigate();

  const id = _.get(userProfile, ["id"]);
  const username = _.get(userProfile, ["username"]);
  const password = _.get(userProfile, ["password"]);
  const role_id = _.get(userProfile, ["role_id"]);
  const email = _.get(userProfile, ["email"]);
  const user_type = _.get(userProfile, ["user_type"]);
  const category_customer_id = _.get(userProfile, ["category_customer_id"]);

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      username,
      email,
      role_id,
      category_customer_id,
    },
  });

  const onHandleEdit = async (data) => {
    const username = _.get(data, ["username"]);
    const password = _.get(data, ["password"]);
    const email = _.get(data, ["email"]);
    const role_id = _.get(data, ["role_id"]);
    const category_customer_id = _.get(data, ["category_customer_id"], null);
    const user_type = _.get(data, ["user_type"]);

    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/user-update",
      isAuth: true,
      data: {
        id,
        username,
        password,
        email,
        role_id,
        user_type,
        category_customer_id,
      },
    });
    if (_.get(resp, ["status"])) {
      setIsModalVisible(false);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Please Re-login",
        showConfirmButton: false,
        timer: 1500,
      });
      setTimeout(() => {
        navigate("/");
        clearLocalStorageAuth();
      }, 1500);
    }
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleEdit)} autoComplete="off">
      <InnerContainer>
        <div>
          <Controller
            name="username"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Username
                </Text>
                <StyledInput
                  label="username"
                  {...field}
                  size="large"
                  placeholder="username"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          <Controller
            name="password"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Password
                </Text>
                <StyledInput
                  label="password"
                  {...field}
                  size="large"
                  placeholder="password"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          <Controller
            name="email"
            control={control}
            rules={_.get(VALIDATE_RULES, ["email"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Email
                </Text>
                <StyledInput
                  label="email"
                  {...field}
                  size="large"
                  placeholder="email"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
        </div>
        <ButtonContainer>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
